import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IBayiTanim_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IBayiTanim_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  DealerSave: number;
  DealerSave_dummy: number;
  GoBack: any;
  GoBack_dummy: any;
  SelectSubsidiary: any[];
  SelectSubsidiary_dummy: any[];
  sbDealerBadges: any[];
  sbDealerBadges_dummy: any[];
  sbCity: any[];
  sbCity_dummy: any[];
  sbKUserList: any[];
  sbKUserList_dummy: any[];
  msDealerCitiesByDealerId: any[];
  msDealerCitiesByDealerId_dummy: any[];
  DealersById: any[];
  DealersById_dummy: any[];
  msSubDealersByParentDealerId: any[];
  msSubDealersByParentDealerId_dummy: any[];
  msDealerKUsers: any[];
  msDealerKUsers_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  ToggleVisibilityOf: string;
  ToggleVisibilityOf_dummy: string;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  LocationCoordinatesOfAdress: any;
  LocationCoordinatesOfAdress_dummy: any;
  SetValueOf: any;
  SetValueOf_dummy: any;
  LocationAdressOfCoordinates: any;
  LocationAdressOfCoordinates_dummy: any;
  isComp458544Visible: "visible" | "hidden";
  isComp856028Visible: "visible" | "hidden";
  isComp226913Visible: "visible" | "hidden";
  isComp285409Visible: "visible" | "hidden";
  isComp550823Visible: "visible" | "hidden";
  isComp728643Visible: "visible" | "hidden";
  isCompbayitanim_602812AuthorizationVisible: "visible" | "hidden";
}

export class BayiTanim_ScreenBase extends React.PureComponent<
  IBayiTanim_ScreenProps,
  any
> {
  bayitanim_122591_value_kuikaSelectBoxRef: React.RefObject<any>;
  bayitanim_688665_value_kuikaPlacesAutocompleteInputRef: React.RefObject<any>;
  bayitanim_140265_value_kuikaLocationPickerComponentRef: React.RefObject<any>;
  ml = [
    {
      Id: "f6e17cbf-9877-1e37-1dda-7f0e2f0194a4",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "58f12691-42c0-4569-8d3d-7de148711af0",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "18add2c8-7d55-4581-a104-dcce9bf5da0c",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 657512, PropertyName: "label", Value: "Kaydet" },
        { Id: 150725, PropertyName: "value", Value: "Bayi Tanımlama" },
        { Id: 975860, PropertyName: "value", Value: "Bayi adı" },
        { Id: 485278, PropertyName: "placeholder", Value: "Bayi adı girin..." },
        { Id: 993249, PropertyName: "value", Value: "Bayi VKN" },
        { Id: 5964, PropertyName: "placeholder", Value: "Bayi VKN girin..." },
        { Id: 120052, PropertyName: "value", Value: "Bayi Ticari Ünvan" },
        {
          Id: 497043,
          PropertyName: "placeholder",
          Value: "Bayi ticari ünvan girin...",
        },
        { Id: 259403, PropertyName: "value", Value: "Bayi Ticari Ünvan" },
        { Id: 122591, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 558460, PropertyName: "value", Value: "Kullanıcı Seçimi" },
        {
          Id: 60559,
          PropertyName: "placeholder",
          Value: "Bayiye bağlı kullanıcıları seçiniz...",
        },
        { Id: 718826, PropertyName: "value", Value: "İlgilendiği Şehirler" },
        {
          Id: 533696,
          PropertyName: "placeholder",
          Value: "Bayi'nin ilgilendiği şehirleri seçin...",
        },
        { Id: 914415, PropertyName: "value", Value: "Belgeler" },
        { Id: 288914, PropertyName: "value", Value: "Adres Yönetimi" },
        { Id: 423649, PropertyName: "value", Value: "Adres Seç" },
        { Id: 688665, PropertyName: "placeholder", Value: "Adres seçin..." },
        { Id: 482152, PropertyName: "value", Value: "Bayi mi?" },
        { Id: 844960, PropertyName: "value", Value: "Alt Bayiler" },
        { Id: 84204, PropertyName: "placeholder", Value: "adress input" },
        { Id: 990084, PropertyName: "placeholder", Value: "lat" },
        { Id: 190640, PropertyName: "placeholder", Value: "long" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.bayitanim_485278_value_kuikaTextInputRef = React.createRef();
    this.bayitanim_5964_value_kuikaTextInputRef = React.createRef();
    this.bayitanim_497043_value_kuikaTextInputRef = React.createRef();
    this.bayitanim_122591_value_kuikaSelectBoxRef = React.createRef();
    this.bayitanim_688665_value_kuikaPlacesAutocompleteInputRef =
      React.createRef();
    this.bayitanim_140265_value_kuikaLocationPickerComponentRef =
      React.createRef();
    this.bayitanim_84204_value_kuikaTextInputRef = React.createRef();
    this.bayitanim_990084_value_kuikaTextInputRef = React.createRef();
    this.bayitanim_190640_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      DealerSave: 0,
      GoBack: "",
      SelectSubsidiary: [],
      sbDealerBadges: [],
      sbCity: [],
      sbKUserList: [],
      msDealerCitiesByDealerId: [],
      DealersById: [],
      msSubDealersByParentDealerId: [],
      msDealerKUsers: [],
      NAVIGATE: "",
      ToggleVisibilityOf: "",
      TriggerEvent: "",
      LocationCoordinatesOfAdress: "",
      SetValueOf: "",
      LocationAdressOfCoordinates: "",
      isComp458544Visible: "hidden",
      isComp856028Visible: "visible",
      isComp226913Visible: "visible",
      isComp285409Visible: "visible",
      isComp550823Visible: "hidden",
      isComp728643Visible: "hidden",
      isCompbayitanim_602812AuthorizationVisible: "visible",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("bayitanim", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.BayiTanimPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompbayitanim_602812AuthorizationVisible",
      ["6ffd9fd2-9d35-4a3c-4405-1c4e97bb6e8c", "Admin"]
    );

    KuikaAppManager.calculateAndSetBodyHeight("bayitanim", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["Admin", "Bayi"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("bayitanim", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.BayiTanimPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      bayitanim_485278_value:
        this.state.DealersById?.at?.(0)?.dealerName ?? undefined,
      bayitanim_5964_value: this.state.DealersById?.at?.(0)?.vkn ?? undefined,
      bayitanim_497043_value:
        this.state.DealersById?.at?.(0)?.tradeName ?? undefined,
      bayitanim_122591_value:
        this.state.DealersById?.at?.(0)?.delaerLevel ?? undefined,
      bayitanim_60559_value:
        this.state.msDealerKUsers?.at?.(0)?.kuserIds ?? undefined,
      bayitanim_533696_value:
        this.state.msDealerCitiesByDealerId?.at?.(0)?.citiesIDs ?? undefined,
      bayitanim_688665_value:
        this.state.DealersById?.at?.(0)?.addressText ?? undefined,
      bayitanim_332799_value:
        this.state.DealersById?.at?.(0)?.isSubsidiary ?? undefined,
      bayitanim_178281_value:
        this.state.msSubDealersByParentDealerId?.at?.(0)?.subDealerIds ??
        undefined,
      bayitanim_84204_value:
        this.state.DealersById?.at?.(0)?.addressText ?? undefined,
      bayitanim_990084_value:
        this.state.DealersById?.at?.(0)?.latitude ?? undefined,
      bayitanim_190640_value:
        this.state.DealersById?.at?.(0)?.longitude ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  BayiTanimPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      DealerID_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      DealerID_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      DealerID_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BayiTanim/BayiTanimPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectSubsidiary = result?.data.selectSubsidiary;
    formVars.bayitanim_178281_value = ReactSystemFunctions.toString(
      this,
      stateVars.msSubDealersByParentDealerId !== undefined
        ? stateVars.msSubDealersByParentDealerId?.length > 0
          ? stateVars.msSubDealersByParentDealerId[0].subDealerIds
          : null
        : this.state.msSubDealersByParentDealerId?.length > 0
        ? this.state.msSubDealersByParentDealerId[0].subDealerIds
        : null
    );

    formVars.bayitanim_178281_value =
      stateVars.msSubDealersByParentDealerId !== undefined
        ? stateVars.msSubDealersByParentDealerId?.length > 0
          ? stateVars.msSubDealersByParentDealerId[0].subDealerIds
          : null
        : this.state.msSubDealersByParentDealerId?.length > 0
        ? this.state.msSubDealersByParentDealerId[0].subDealerIds
        : null;
    formVars.bayitanim_178281_options = stateVars.SelectSubsidiary;
    stateVars.sbDealerBadges = result?.data.sbDealerBadges;

    formVars.bayitanim_122591_value =
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].delaerLevel
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].delaerLevel
        : null;
    formVars.bayitanim_122591_options = stateVars.sbDealerBadges;
    stateVars.sbCity = result?.data.sbCity;
    formVars.bayitanim_533696_value = ReactSystemFunctions.toString(
      this,
      stateVars.msDealerCitiesByDealerId !== undefined
        ? stateVars.msDealerCitiesByDealerId?.length > 0
          ? stateVars.msDealerCitiesByDealerId[0].citiesIDs
          : null
        : this.state.msDealerCitiesByDealerId?.length > 0
        ? this.state.msDealerCitiesByDealerId[0].citiesIDs
        : null
    );

    formVars.bayitanim_533696_value =
      stateVars.msDealerCitiesByDealerId !== undefined
        ? stateVars.msDealerCitiesByDealerId?.length > 0
          ? stateVars.msDealerCitiesByDealerId[0].citiesIDs
          : null
        : this.state.msDealerCitiesByDealerId?.length > 0
        ? this.state.msDealerCitiesByDealerId[0].citiesIDs
        : null;
    formVars.bayitanim_533696_options = stateVars.sbCity;
    stateVars.sbKUserList = result?.data.sbKUserList;
    formVars.bayitanim_60559_value = ReactSystemFunctions.toString(
      this,
      stateVars.msDealerKUsers !== undefined
        ? stateVars.msDealerKUsers?.length > 0
          ? stateVars.msDealerKUsers[0].kuserIds
          : null
        : this.state.msDealerKUsers?.length > 0
        ? this.state.msDealerKUsers[0].kuserIds
        : null
    );

    formVars.bayitanim_60559_value =
      stateVars.msDealerKUsers !== undefined
        ? stateVars.msDealerKUsers?.length > 0
          ? stateVars.msDealerKUsers[0].kuserIds
          : null
        : this.state.msDealerKUsers?.length > 0
        ? this.state.msDealerKUsers[0].kuserIds
        : null;
    formVars.bayitanim_60559_options = stateVars.sbKUserList;
    stateVars.msDealerCitiesByDealerId = result?.data.msDealerCitiesByDealerId;
    formVars.bayitanim_533696_value = ReactSystemFunctions.toString(
      this,
      stateVars.msDealerCitiesByDealerId !== undefined
        ? stateVars.msDealerCitiesByDealerId?.length > 0
          ? stateVars.msDealerCitiesByDealerId[0].citiesIDs
          : null
        : this.state.msDealerCitiesByDealerId?.length > 0
        ? this.state.msDealerCitiesByDealerId[0].citiesIDs
        : null
    );
    formVars.bayitanim_533696_value =
      stateVars.msDealerCitiesByDealerId !== undefined
        ? stateVars.msDealerCitiesByDealerId?.length > 0
          ? stateVars.msDealerCitiesByDealerId[0].citiesIDs
          : null
        : this.state.msDealerCitiesByDealerId?.length > 0
        ? this.state.msDealerCitiesByDealerId[0].citiesIDs
        : null;
    formVars.bayitanim_533696_options = stateVars.sbCity;
    stateVars.DealersById = result?.data.dealersById;
    formVars.bayitanim_485278_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].dealerName
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].dealerName
        : null
    );
    formVars.bayitanim_5964_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].vkn
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].vkn
        : null
    );
    formVars.bayitanim_497043_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].tradeName
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].tradeName
        : null
    );
    formVars.bayitanim_122591_value =
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].delaerLevel
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].delaerLevel
        : null;
    formVars.bayitanim_122591_options = stateVars.sbDealerBadges;
    formVars.bayitanim_688665_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].addressText
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].addressText
        : null
    );
    formVars.bayitanim_140265_latitude = ReactSystemFunctions.toDecimal(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].latitude
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].latitude
        : null
    );
    formVars.bayitanim_140265_longitude = ReactSystemFunctions.toDecimal(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].longitude
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].longitude
        : null
    );
    formVars.bayitanim_332799_value = ReactSystemFunctions.value(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].isSubsidiary
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].isSubsidiary
        : null
    );
    formVars.bayitanim_84204_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].addressText
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].addressText
        : null
    );
    formVars.bayitanim_990084_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].latitude
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].latitude
        : null
    );
    formVars.bayitanim_190640_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].longitude
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].longitude
        : null
    );
    stateVars.msSubDealersByParentDealerId =
      result?.data.msSubDealersByParentDealerId;
    formVars.bayitanim_178281_value = ReactSystemFunctions.toString(
      this,
      stateVars.msSubDealersByParentDealerId !== undefined
        ? stateVars.msSubDealersByParentDealerId?.length > 0
          ? stateVars.msSubDealersByParentDealerId[0].subDealerIds
          : null
        : this.state.msSubDealersByParentDealerId?.length > 0
        ? this.state.msSubDealersByParentDealerId[0].subDealerIds
        : null
    );
    formVars.bayitanim_178281_value =
      stateVars.msSubDealersByParentDealerId !== undefined
        ? stateVars.msSubDealersByParentDealerId?.length > 0
          ? stateVars.msSubDealersByParentDealerId[0].subDealerIds
          : null
        : this.state.msSubDealersByParentDealerId?.length > 0
        ? this.state.msSubDealersByParentDealerId[0].subDealerIds
        : null;
    formVars.bayitanim_178281_options = stateVars.SelectSubsidiary;
    stateVars.msDealerKUsers = result?.data.msDealerKUsers;
    formVars.bayitanim_60559_value = ReactSystemFunctions.toString(
      this,
      stateVars.msDealerKUsers !== undefined
        ? stateVars.msDealerKUsers?.length > 0
          ? stateVars.msDealerKUsers[0].kuserIds
          : null
        : this.state.msDealerKUsers?.length > 0
        ? this.state.msDealerKUsers[0].kuserIds
        : null
    );
    formVars.bayitanim_60559_value =
      stateVars.msDealerKUsers !== undefined
        ? stateVars.msDealerKUsers?.length > 0
          ? stateVars.msDealerKUsers[0].kuserIds
          : null
        : this.state.msDealerKUsers?.length > 0
        ? this.state.msDealerKUsers[0].kuserIds
        : null;
    formVars.bayitanim_60559_options = stateVars.sbKUserList;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BayiTanimPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BayiTanimPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.bayitanim_485278_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].dealerName
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].dealerName
        : null
    );

    formVars.bayitanim_5964_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].vkn
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].vkn
        : null
    );

    formVars.bayitanim_497043_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].tradeName
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].tradeName
        : null
    );

    formVars.bayitanim_122591_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].delaerLevel
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].delaerLevel
        : null
    );

    stateVars.dataSource_122591 =
      stateVars.sbDealerBadges ?? this.state.sbDealerBadges;
    stateVars.dataSource_122591 =
      stateVars.sbDealerBadges ?? this.state.sbDealerBadges;
    formVars.bayitanim_60559_value = ReactSystemFunctions.toString(
      this,
      stateVars.msDealerKUsers !== undefined
        ? stateVars.msDealerKUsers?.length > 0
          ? stateVars.msDealerKUsers[0].kuserIds
          : null
        : this.state.msDealerKUsers?.length > 0
        ? this.state.msDealerKUsers[0].kuserIds
        : null
    );

    stateVars.dataSource_60559 =
      stateVars.sbKUserList ?? this.state.sbKUserList;
    stateVars.dataSource_60559 =
      stateVars.sbKUserList ?? this.state.sbKUserList;
    formVars.bayitanim_533696_value = ReactSystemFunctions.toString(
      this,
      stateVars.msDealerCitiesByDealerId !== undefined
        ? stateVars.msDealerCitiesByDealerId?.length > 0
          ? stateVars.msDealerCitiesByDealerId[0].citiesIDs
          : null
        : this.state.msDealerCitiesByDealerId?.length > 0
        ? this.state.msDealerCitiesByDealerId[0].citiesIDs
        : null
    );

    stateVars.dataSource_533696 = stateVars.sbCity ?? this.state.sbCity;
    stateVars.dataSource_533696 = stateVars.sbCity ?? this.state.sbCity;
    formVars.bayitanim_688665_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].addressText
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].addressText
        : null
    );

    var value_140265 = {} as any;
    value_140265.latitude = ReactSystemFunctions.toDecimal(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].latitude
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].latitude
        : null
    );
    value_140265.longitude = ReactSystemFunctions.toDecimal(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].longitude
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].longitude
        : null
    );

    formVars.bayitanim_140265_value = value_140265;
    var value_140265 = {} as any;
    value_140265.latitude = ReactSystemFunctions.toDecimal(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].latitude
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].latitude
        : null
    );
    value_140265.longitude = ReactSystemFunctions.toDecimal(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].longitude
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].longitude
        : null
    );

    formVars.bayitanim_140265_value = value_140265;
    formVars.bayitanim_332799_value = ReactSystemFunctions.value(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].isSubsidiary
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].isSubsidiary
        : null
    );

    stateVars.isComp550823Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_332799_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.bayitanim_178281_value = ReactSystemFunctions.toString(
      this,
      stateVars.msSubDealersByParentDealerId !== undefined
        ? stateVars.msSubDealersByParentDealerId?.length > 0
          ? stateVars.msSubDealersByParentDealerId[0].subDealerIds
          : null
        : this.state.msSubDealersByParentDealerId?.length > 0
        ? this.state.msSubDealersByParentDealerId[0].subDealerIds
        : null
    );

    stateVars.dataSource_178281 =
      stateVars.SelectSubsidiary ?? this.state.SelectSubsidiary;
    stateVars.dataSource_178281 =
      stateVars.SelectSubsidiary ?? this.state.SelectSubsidiary;
    formVars.bayitanim_84204_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].addressText
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].addressText
        : null
    );

    formVars.bayitanim_990084_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].latitude
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].latitude
        : null
    );

    formVars.bayitanim_190640_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealersById !== undefined
        ? stateVars.DealersById?.length > 0
          ? stateVars.DealersById[0].longitude
          : null
        : this.state.DealersById?.length > 0
        ? this.state.DealersById[0].longitude
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  BayiTanimComponent_657512_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "bayitanim_485278_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "*",
      formName: "bayitanim_485278_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "bayitanim_533696_value",
          "value",
          "sbCity",
          "id",
          ""
        ),
        null
      ),
      message: "*",
      formName: "bayitanim_533696_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "bayitanim_485278_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "*",
      formName: "bayitanim_5964_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "bayitanim_485278_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "*",
      formName: "bayitanim_497043_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DealerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      AddressText_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_84204_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      DealerName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_485278_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      IsSubsidiary_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_332799_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      Latitude_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_990084_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Longitude_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_190640_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      UserIDs_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_60559_value",
            "value",
            "sbKUserList",
            "id",
            "id"
          )
        ),
        "string"
      ),
      Cities_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_533696_value",
            "value",
            "sbCity",
            "id",
            "id"
          )
        ),
        "string"
      ),
      SubDealers_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_178281_value",
            "value",
            "SelectSubsidiary",
            "id",
            "id"
          )
        ),
        "string"
      ),
      VKN_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_5964_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      TradeName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_497043_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      DelaerLevel_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_122591_value",
            "value",
            "sbDealerBadges",
            "name",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BayiTanim/BayiTanimComponent_657512_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DealerSave = result?.data.dealerSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BayiTanimComponent_657512_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BayiTanimComponent_657512_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiTanimComponent_745360_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiTanimComponent_555343_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiTanimComponent_105919_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BayiBelgeList",
      "DealerID",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BayiTanim",
      "BayiBelgeList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiTanimComponent_458544_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp458544Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp856028Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp226913Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp285409Visible",
          "string"
        )
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiTanimComponent_856028_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    if (await this.BayiTanimComponent_458544_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiTanimComponent_688665_onSelectPlace = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "bayitanim_688665_value",
          "Address",
          "",
          "",
          ""
        ),
        null
      ),
      message: "*",
      formName: "bayitanim_688665_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.LocationCoordinatesOfAdress = (
      (await ReactSystemFunctions.locationCoordinatesOfAdress(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_688665_value",
            "Address",
            "",
            "",
            ""
          )
        )
      )) as any
    ).data;
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bayitanim_140265_value",
        "string"
      ),
      ReactSystemFunctions.toDecimal(
        this,
        ReactSystemFunctions.value(
          this,
          "bayitanim_688665_value",
          "Latitude",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.convertToTypeByName("latitude", "string"),
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bayitanim_140265_value",
        "string"
      ),
      ReactSystemFunctions.toDecimal(
        this,
        ReactSystemFunctions.value(
          this,
          "bayitanim_688665_value",
          "Longitude",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.convertToTypeByName("longitude", "string"),
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bayitanim_84204_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "bayitanim_688665_value",
          "Address",
          "",
          "",
          ""
        )
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bayitanim_990084_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "bayitanim_688665_value",
          "Latitude",
          "",
          "",
          ""
        )
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bayitanim_190640_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "bayitanim_688665_value",
          "Longitude",
          "",
          "",
          ""
        )
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiTanimComponent_140265_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.LocationAdressOfCoordinates = (
      (await ReactSystemFunctions.locationAdressOfCoordinates(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_140265_value",
            "Latitude",
            "",
            "",
            ""
          )
        ),
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_140265_value",
            "Longitude",
            "",
            "",
            ""
          )
        )
      )) as any
    ).data;
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bayitanim_688665_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.LocationAdressOfCoordinates?.address
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bayitanim_84204_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.LocationAdressOfCoordinates?.address
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bayitanim_990084_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "bayitanim_140265_value",
          "Latitude",
          "",
          "",
          ""
        )
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bayitanim_190640_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "bayitanim_140265_value",
          "Longitude",
          "",
          "",
          ""
        )
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiTanimComponent_332799_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isComp550823Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bayitanim_332799_value",
            "value",
            "",
            "",
            ""
          )
        ),
        false
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.BayiTanimPageInit();
    }
  }
}
